import { CoreIcon } from '../core-icon';
import callSVG from '../../assets/icons/call.svg';
import type { IconProps } from '../core-icon';

export const CallIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={callSVG} {...props} />;
};
